// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__HAeMr","tabsItem":"Tabs_tabsItem__+NRf0","tabsActive":"Tabs_tabsActive__ddSVf"};